import React from 'react';
import { useToast } from 'contexts/ToastContext';
import KskToast from 'ksk/styledComponents/components/KskToast/KskToast';
import useElementHeight from 'ksk/hooks/useElementHeight';

function MainContent({children, backgroundColor = '#f8f8f8', noMainContentPadding = false}) {
  const { notification, dismiss } = useToast();
  const [wrapperRef, toastHeight] = useElementHeight(notification);

  return (
    <main id="main" className={`legacy d-flex flex-fill${noMainContentPadding ? '' : ' pb-5'}`} style={{ backgroundColor }}>
      {notification && (
        <KskToast ref={wrapperRef} notification={notification} onDismiss={dismiss} />
      )}
      <div className="container-fluid" style={{ ...(toastHeight && { paddingTop: toastHeight }) }}>
        {children}
      </div>
    </main>
  )
}

export default MainContent;
